import axios from 'axios';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import store from '../store'
import { Message,MessageBox } from 'element-ui';


function getFile(url){
    
    return new Promise((resolve, reject) => {
        axios({
            method:'get',
            url,
            responseType: 'arraybuffer',
        }).then(data => {
            resolve(data.data)
        }).catch(error => {
            reject(error.toString())
        })
    })
}
export function batchDownload(list) {
    store.dispatch('global/setLoading', true);
    const data = list;
   
    // const data = ['各类地址1', '各类地址2'] // 需要下载打包的路径, 可以是本地相对路径, 也可以是跨域的全路径
    const zip = new JSZip()
    const cache = {}
    const promises = []
    let alertMessage = '';
    data.forEach((item,index) => {
        const promise = getFile(item.path).then(data => { // 下载文件, 并存成ArrayBuffer对象
            let nameList = item.name.split('.');
            const file_name = (index+1)+'、'+nameList[0]+'.'+item.materialType // 获取文件名
            zip.file(file_name, data, { binary: true }) // 逐个添加文件
            cache[file_name] = data
        }).catch(error => {
            // Message({
            //     message: '文件《'+item.name+'》压缩失败，请手动复制下载',
            //     type: 'error',
            //     duration:'5000'
            // });
            
            if(alertMessage==''){
                alertMessage ='《'+item.name+'》'
            }else{
                alertMessage = alertMessage+'、《'+item.name+'》'
            }
        })
        promises.push(promise);
    })
    
    Promise.all(promises).then(() => {
        zip.generateAsync({type:"blob"}).then(content => { // 生成二进制流
            if(alertMessage){
                MessageBox ('文件'+alertMessage+'压缩失败，请手动复制下载。', '提示',{
                    confirmButtonText: '确定',
                    type:'error',
                    callback: action => {
                    }
                });
            }
            FileSaver.saveAs(content, "派工资料.zip") // 利用file-saver保存文件
            store.dispatch('global/setLoading', false)
        }).catch(error => {
           
        })
    })
}
export function batchDownloadList(list) {
    store.dispatch('global/setLoading', true);
    const data = list;
    const zip = new JSZip()
    const cache = {}
    const promises = []
    data.forEach((item,index) => {
        var folderName = zip.folder(item.key);
        item.data.forEach((citem,cIndex) => {
            const promise = getFile(citem.path).then(data => { // 下载文件, 并存成ArrayBuffer对象
                let nameList = citem.fileName.split('.');
                const file_name = (cIndex+1)+'、'+nameList[0]+'.'+citem.fileType // 获取文件名
                cache[file_name] = data
                folderName.file(file_name, data, { binary: true }) // 逐个添加文件
            }).catch(error => {
            })
            promises.push(promise);
        })

    })
    Promise.all(promises).then(() => {
        console.log(zip);
        zip.generateAsync({type:"blob"}).then(content => { // 生成二进制流
            FileSaver.saveAs(content, "调查资料.zip") // 利用file-saver保存文件
            store.dispatch('global/setLoading', false)
        }).catch(error => {
            console.log('error1');
            console.log(error);
        })
    }).catch(error => {
        console.log('error2');
        console.log(error);
    })
}